<template>
  <div
    class="currency_card b-radius-12"
    :class="[slug]"
    @mouseenter.native="$isMobile() ? null : handleArrowEvent('inside')"
    @mouseleave.native="$isMobile() ? null : handleArrowEvent('outside')"
  >
    <img :src="image" class="currency_image b-radius-9" alt="currency_image" />
    <div class="d-flex-column justify-start align-start gap-12">
      <div class="d-flex-column justify-start align-start gap-9">
        <p class="t-white font-family-2 bold-xxl">{{ title }}</p>
        <div class="caps bold-m t-grey font-family-2 currency_chip b-radius-5">
          {{ $t("dashboard.currency") }}
        </div>
      </div>

      <div class="d-flex-row space-between height-max-content">
        <div class="arrow_right" ref="arrow_right">
          <h4
            class="t-white bold-s f-w-600 font-family-1 text white-space-no flex-4"
            ref="arrow_right_text"
          >
            {{ $t("main.buy_now") }}
          </h4>
          <arrow-right />
        </div>

        <div class="d-flex-row justify-end flex-3 gap-5">
          <p class="t-light font-family-2 regular-l">{{ $t("from") }}</p>
          <p class="font-family-2 bold-xxl" style="color: var(--path-of-exile)">
            ${{ parseFloat(price).toFixed(2) }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import ArrowRight from "../icons/ArrowRight.vue";
const props = defineProps({
  slug: {
    default: "",
  },
  title: {
    default: "",
  },
  image: {
    default: "",
  },
  price: {
    default: 0,
  },
});
const arrow_right = ref(null);
const arrow_right_text = ref(null);

const handleArrowEvent = (prompt) => {
  const el = arrow_right.value;
  const width = el?.getBoundingClientRect();
  const elText = arrow_right_text.value;
  const elWidth = elText?.getBoundingClientRect();
  if (!el) return;
  if (prompt === "outside") {
    el.style.width = "36px";
  }
  if (prompt === "inside") {
    const calWidth = elWidth?.width + width?.width + 12;
    el.style.width = `${calWidth}px`;
  }
};
</script>

<style lang="scss">
.currency_card {
  background-color: var(--bg-dark);
  padding: 9px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  gap: 12px;
  overflow: hidden;
  & > * {
    z-index: 1;
  }
  cursor: pointer;
  position: relative;
  .currency_image {
    width: 100%;
    height: auto;
    object-fit: cover;
    object-position: center;
    max-height: 180px;
  }
  .currency_chip {
    padding: 3px 6px;
    background-color: rgba(255, 255, 255, 0.05);
  }
  &::before {
    content: "";
    height: 25%;
    max-height: 200px;
    width: 100%;
    max-width: 250px;
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translate(-50%, 0%);
    background-color: var(--path-of-exile);
    z-index: 0;
    border-radius: 50%;
    filter: blur(50px);
    transition: all 0.2s ease;
    opacity: 0;
    // opacity: 1;
  }

  .arrow_right {
    z-index: 1;
    transition: all 0.2s ease;
    width: 36px;
    padding: 0 10px;
    height: 36px;
    background-color: #171b1c;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    border-radius: 24px;
    overflow: hidden;
    .text {
      opacity: 0;
      display: none;
    }
  }

  &:hover {
    &::before {
      opacity: 1;
    }

    .arrow_right {
      background-color: var(--path-of-exile);
      img {
        filter: brightness(0);
      }
      .text {
        display: flex;
        opacity: 1;
        color: var(--text-black) !important;
      }
    }
  }

  @media screen and (max-width: 480px) {
    flex-direction: row;
    .currency_image {
      width: 104px;
      height: 104px;
    }

    &:hover {
      .arrow_right {
        .text {
          display: none;
        }
      }
    }
  }
}
</style>
